module.exports = __webpack_public_path__ + "static/media/google_pay.fc25f36a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/google_pay.svg
// module id = 334
// module chunks = 21